<template>
  <div class="video_wrap">
    <button @click="addroom">进入房间</button>
    <div class="content">
      <!-- 远端视频 -->
      <div v-for="(item, index) in remoteStreamList" :key="index" class="remote-stream">
        <div v-html="item.view" :class="{ 'distant-stream': item.view }"></div>
      </div>
      <!-- 本地视频 -->
      <div id="local_stream" class="local-stream"></div>
    </div>
  </div>
</template>
<script>
// import LibGenerateTestUserSig from '@/utils/lib-generate-test-usersig.min.js'
import TRTC from "trtc-js-sdk";
// import { getUrlParam } from '@/utils/utils.js';

export default {
  data() {
    return {
      SDKAPPIDConfig: Number(this.$route.query.SDKAPPIDConfig),
      userSig: this.$route.query.userSig,
      // SECRETKEYConfig: '36bf2a4df51c7da7d42178c82c1a79fd0aaaf710aaf03ecfa976da0b700da333',
      userId: this.$route.query.userId,
      roomId: this.$route.query.roomId,
      client: "", // 客户端服务
      remoteStream: "", // 远方播放流
      localStream: "", // 本地流
      remoteStreamList: [] // 远端小视频
    };
  },
  mounted() {
    // this.createClient()
  },
  methods: {
    addroom() {
      this.createClient();
    },
    // 可以绑定在按钮上，点击按钮，进行视频通话
    createClient() {
      console.log(this.roomId);
      console.log(this.userId);
      console.log(this.userSig);
      
      this.localStream = "";
      this.remoteStreamList = [];
      // 获取签名
      // const config = this.genTestUserSig(this.userId)
      const sdkAppId = this.SDKAPPIDConfig;
      const userSig = this.userSig;
      const userId = this.userId;
      this.client = TRTC.createClient({
        mode: "rtc", // 实时音视频通话
        sdkAppId,
        userId,
        userSig
      });
      // 注册远程监听
      this.subscribeStream(this.client);
      // 注册监听事件 如，房间关闭
      this.handleEvents(this.client);
      // 初始化成功后才能加入房间
      this.joinRoom(this.client, this.roomId);
    },

    // 订阅远端流--加入房间之前
    subscribeStream(client) {
      client.on("stream-added", event => {
        const remoteStream = event.stream;
        console.log("远端流增加: " + remoteStream.getId());
        // 订阅远端流
        client.subscribe(remoteStream);
      });
    },

    handleEvents(client) {
      client.on("stream-subscribed", event => {
        const remoteStream = event.stream;
        console.log("远端流订阅成功：" + remoteStream.getId());
        // 创建远端流标签，因为id是动态的，所以动态创建，用了v-html
        let remoteStreamItem = `<div id="${"remote_stream-" +
          remoteStream.getId()}"  ></div>`;
        let isExist = this.remoteStreamList.find(
          item => item.userId === remoteStream.getUserId()
        );
        if (!isExist) {
          this.remoteStreamList.push({
            id: remoteStream.getId(),
            userId: remoteStream.getUserId(),
            view: remoteStreamItem,
            hasVideo: true, // 是否开启了摄像头
            hasMic: true // 是否开启了麦克风
          });

          // 做了dom操作 需要使用$nextTick(),否则找不到创建的标签无法进行播放
          this.$nextTick(() => {
            //播放远端流
            remoteStream.play("remote_stream-" + remoteStream.getId());
          });
        }
      });
    },

    // 加入房间
    joinRoom(client, roomId) {
      client
        .join({ roomId })
        .catch(error => {
          console.error("进房失败 " + error);
        })
        .then(() => {
          console.log("进房成功");
          // 创建本地流
          this.createStream(this.userId);
        });
    },
    // 创建本地音频流
    async createStream(userId) {
      const localStream = TRTC.createStream({
        userId,
        audio: true,
        video: true
      });
      // 设置视频属性 Profile 为 '480p'
      localStream.setVideoProfile("480p");

      this.localStream = localStream;

      try {
        await localStream
          .initialize()
          // .catch(error => {
          //   console.error('初始化本地流失败 ' + error)
          // })
          .then(() => {
            console.log("初始化本地流成功");
            // 创建好后才能播放 本地流播放 local_stream 是div的id
            localStream.play("local_stream");
            // 创建好后才能发布
            this.publishStream(localStream, this.client);
          });
      } catch (error) {
        switch (error.name) {
          case "NotReadableError":
            alert(
              "暂时无法访问摄像头/麦克风，请确保系统允许当前浏览器访问摄像头/麦克风，并且没有其他应用占用摄像头/麦克风"
            );
            break;
          case "NotAllowedError":
            if (error.message === "Permission denied by system") {
              alert("请确保系统允许当前浏览器访问摄像头/麦克风");
            } else {
              console.log("User refused to share the screen");
              alert("请确保系统允许当前浏览器访问摄像头/麦克风");
            }
            break;
          case "NotFoundError":
            alert(
              "浏览器获取不到摄像头/麦克风设备，请检查设备连接并且确保系统允许当前浏览器访问摄像头/麦克风"
            );
            break;
          default:
            break;
        }
      }
    },
    // 发布本地音视频流
    publishStream(localStream, client) {
      client
        .publish(localStream)
        .catch(error => {
          console.error("本地流发布失败 " + error);
        })
        .then(() => {
          console.log("本地流发布成功");
        });
    },

    // 退出房间
    logoutHandler() {
      this.leaveRoom(this.client);
    },
    leaveRoom(client) {
      client
        .leave()
        .then(() => {
          console.log("退房成功");
          // 停止本地流，关闭本地流内部的音视频播放器
          this.localStream.stop();
          // 关闭本地流，释放摄像头和麦克风访问权限
          this.localStream.close();
          this.localStream = null;
          this.client = null;
          // 退房成功，可再次调用client.join重新进房开启新的通话。
        })
        .catch(error => {
          console.error("退房失败 " + error);
          // 错误不可恢复，需要刷新页面。
        });
    }
  }
};
</script>

<style scoped>
.local-stream {
  width: 500px;
  height: 500px;
}

.remote-stream {
  width: 200px;
  height: 200px;
}
</style>
